<template>
	<div class="content-wrapper">
		<div class="row">
			<div class="col-12 mb-primary">
				<div class="card card-with-shadow border-0 h-10">
					<div class="card-header p-primary bg-transparent"></div>
					<app-overlay-loader v-if="preloader" />
					<div class="card-body">
						<!-- Class Information Form -->
						<div class="col-md-12">
							<app-breadcrumb page-title="Class Information" />
							<hr
								style="
									border-top: 2px solid black;
									font-weight: bold;
								"
							/>
							<form
								ref="form"
								:data-url="`/transaction/invoice/${id}`"
								class="mb-0"
								:class="{ 'loading-opacity': preloader }"
							>
								<div class="row">
									<div class="col-lg-12">
										<div class="row">
											<div class="col-md-3">
												<div class="form-group">
													<label
														for="inputs_course_id"
														>Class Name</label
													>
													<app-input
														id="inputs_course_id"
														type="advance-search-select"
														:loaded-per-time="10"
														v-model="
															input_course_id
														"
														@input="
															setCourseIdValue
														"
														fetch-url="transaction/course"
														placeholder="Class Name"
														list-value-field="course_name"
														required
													/>
												</div>
											</div>

											<div class="col-md-3">
												<div class="form-group">
													<label
														for="inputs_group_course_id"
														>Group Class</label
													>
													<app-input
														id="inputs_group_course_id"
														type="advance-search-select"
														:loaded-per-time="10"
														v-model="
															input_group_course_id
														"
														@input="
															setGroupCourseIdValue
														"
														fetch-url="transaction/course-group"
														placeholder="Group Class"
														list-value-field="course_group_name"
														required
													/>
												</div>
											</div>

											<div class="col-md-3">
												<div class="form-group">
													<label
														for="inputs_main_teacher_id"
														>Main Teacher</label
													>
													<app-input
														id="inputs_main_teacher_id"
														type="advance-search-select"
														:loaded-per-time="10"
														v-model="
															input_main_teacher_id
														"
														@input="
															setMainTeacherIdValue
														"
														fetch-url="user-list"
														placeholder="Main Teacher"
														list-value-field="full_name"
														required
													/>
												</div>
											</div>

											<div class="col-md-3">
												<div class="form-group">
													<label
														for="inputs_student_care_1_id"
														>Student Care #1</label
													>
													<app-input
														id="inputs_student_care_1_id"
														type="advance-search-select"
														:loaded-per-time="10"
														v-model="
															input_student_care_1_id
														"
														@input="
															setStudentCare1IdValue
														"
														fetch-url="user-list"
														placeholder="Student Care #1"
														list-value-field="full_name"
														required
													/>
												</div>
											</div>

											<div class="col-md-3">
												<div class="form-group">
													<label
														for="inputs_course_type_id"
														>Class Type</label
													>
													<app-input
														id="inputs_course_type_id"
														type="advance-search-select"
														:loaded-per-time="10"
														v-model="
															input_course_type_id
														"
														@input="
															setCourseTypeIdValue
														"
														fetch-url="master/course-type"
														placeholder="Class Type"
														list-value-field="course_type_name"
														required
													/>
												</div>
											</div>

											<div class="col-md-3">
												<div class="form-group">
													<label
														for="inputs_start_week"
														>Start Week</label
													>
													<app-input
														id="inputs_start_week"
														type="text"
														v-model="
															classInformationForm.start_week
														"
														placeholder="Start Week"
														required
													/>
												</div>
											</div>

											<div class="col-md-3">
												<div class="form-group">
													<label
														for="inputs_co_teacher_id"
														>CO Teacher</label
													>
													<app-input
														id="inputs_co_teacher_id"
														type="advance-search-select"
														:loaded-per-time="10"
														v-model="
															input_co_teacher_id
														"
														@input="
															setCoTeacherIdValue
														"
														fetch-url="user-list"
														placeholder="CO Teacher"
														list-value-field="full_name"
														required
													/>
												</div>
											</div>

											<div class="col-md-3">
												<div class="form-group">
													<label
														for="inputs_student_care_2_id"
														>Student Care #2</label
													>
													<app-input
														id="inputs_student_care_2_id"
														type="advance-search-select"
														:loaded-per-time="10"
														v-model="
															input_student_care_2_id
														"
														@input="
															setStudentCare2IdValue
														"
														fetch-url="user-list"
														placeholder="Student Care #2"
														list-value-field="full_name"
														required
													/>
												</div>
											</div>

											<div class="col-md-3">
												<div class="form-group">
													<label
														for="inputs_center_id"
														>CLC Centre</label
													>
													<app-input
														id="inputs_center_id"
														type="advance-search-select"
														:loaded-per-time="10"
														v-model="
															input_center_id
														"
														@input="
															setCenterIdValue
														"
														fetch-url="master/center"
														placeholder="CLC Centre"
														list-value-field="name"
														required
													/>
												</div>
											</div>

											<div class="col-md-3">
												<div class="form-group">
													<label for="inputs_end_week"
														>End Week</label
													>
													<app-input
														id="inputs_end_week"
														type="text"
														v-model="
															classInformationForm.end_week
														"
														placeholder="End Week"
														required
													/>
												</div>
											</div>

											<div class="col-md-3">
												<div class="form-group">
													<label
														for="inputs_teacher_trainer_id"
														>Teacher Trainer</label
													>
													<app-input
														id="inputs_teacher_trainer_id"
														type="advance-search-select"
														:loaded-per-time="10"
														v-model="
															input_teacher_trainer_id
														"
														@input="
															setTeacherTrainerIdValue
														"
														fetch-url="user-list"
														placeholder="Teacher Trainer"
														list-value-field="full_name"
														required
													/>
												</div>
											</div>

											<div class="col-md-3">
												<div class="form-group">
													<label
														for="inputs_sc_supervisor_id"
														>SC Supervisor</label
													>
													<app-input
														id="inputs_sc_supervisor_id"
														type="advance-search-select"
														:loaded-per-time="10"
														v-model="
															input_sc_supervisor_id
														"
														@input="
															setScSupervisorIdValue
														"
														fetch-url="user-list"
														placeholder="SC Supervisor"
														list-value-field="full_name"
														required
													/>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="mt-5 mb-5 action-buttons">
									<button
										type="submit"
										class="btn btn-primary mr-2"
										:disabled="
											this.classInformationForm
												.invoice_no != null ||
											this.classInformationForm.status ==
												'Cancelled'
										"
										@click.prevent="submitClassInformation"
									>
										Submit
									</button>
								</div>
							</form>
						</div>

						<!-- Study Details Table -->
						<div class="col-md-12 mt-8">
							<student-profile-tab-class-study-details-table></student-profile-tab-class-study-details-table>
						</div>

						<!-- Student Attendance Table -->
						<div class="col-md-12 mt-8">
							<student-profile-tab-class-student-attendance-table></student-profile-tab-class-student-attendance-table>
						</div>

						<!-- Fees Notice Details Charges -->
						<div class="col-md-12 mt-8"></div>

						<!-- Fees Notice Details Deductions -->
						<div class="col-md-12 mt-8"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import GlobalHelperMixin from "../../../../../../../Mixins/global/GlobalHelperMixin";

export default {
	name: "ClassInformation",
	inject: ["eventHub"],
	mixins: [FormMixin, GlobalHelperMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			sameAsAbove: false,
			id: null,
			input_course_id: this.value
				? this.value.course
					? {
							id: this.value.course.id || 0,
							course_name: this.value.course.course_name || "",
							is_active: this.value.course.is_active,
					  }
					: {
							id: this.value.course?.id || 0,
							course_name: this.value.course?.course_name || "",
							is_active: this.value.course?.is_active,
					  }
				: {
						id: this.value.course.id || 0,
						course_name: this.value.course.course_name || "",
						is_active: this.value.course.is_active,
				  },
			input_course_type_id: this.value
				? this.value.course_type
					? {
							id: this.value.course_type.id || 0,
							course_type_name:
								this.value.course_type.course_type_name || "",
							is_active: this.value.course_type.is_active,
					  }
					: {
							id: this.value.course_type?.id || 0,
							course_type_name:
								this.value.course_type?.course_type_name || "",
							is_active: this.value.course_type?.is_active,
					  }
				: {
						id: this.value.course_type.id || 0,
						course_type_name:
							this.value.course_type.course_type_name || "",
						is_active: this.value.course_type.is_active,
				  },
			input_center_id: this.value
				? this.value.center
					? {
							id: this.value.center.id || 0,
							name: this.value.center.name || "",
							is_active: this.value.center.is_active,
					  }
					: {
							id: this.value.center?.id || 0,
							name: this.value.center?.name || "",
							is_active: this.value.center?.is_active,
					  }
				: {
						id: this.value.center.id || 0,
						name: this.value.center.name || "",
						is_active: this.value.center.is_active,
				  },
			input_group_course_id: this.value
				? this.value.course_group
					? {
							id: this.value.course_group.id || 0,
							course_group_name:
								this.value.course_group.course_group_name || "",
							is_active: this.value.course_group.is_active,
					  }
					: {
							id: this.value.course_group?.id || 0,
							course_group_name:
								this.value.course_group?.course_group_name ||
								"",
							is_active: this.value.course_group?.is_active,
					  }
				: {
						id: this.value.course_group.id || 0,
						course_group_name:
							this.value.course_group.course_group_name || "",
						is_active: this.value.course_group.is_active,
				  },
			input_main_teacher_id: this.value
				? this.value.main_teacher
					? {
							id: this.value.main_teacher.id || 0,
							full_name: this.value.main_teacher.full_name || "",
							is_active: this.value.main_teacher.is_active,
					  }
					: {
							id: this.value.main_teacher?.id || 0,
							full_name: this.value.main_teacher?.full_name || "",
							is_active: this.value.main_teacher?.is_active,
					  }
				: {
						id: this.value.main_teacher.id || 0,
						full_name: this.value.main_teacher.full_name || "",
						is_active: this.value.main_teacher.is_active,
				  },
			input_student_care_1_id: this.value
				? this.value.student_care_1
					? {
							id: this.value.student_care_1.id || 0,
							full_name:
								this.value.student_care_1.full_name || "",
							is_active: this.value.student_care_1.is_active,
					  }
					: {
							id: this.value.student_care_1?.id || 0,
							full_name:
								this.value.student_care_1?.full_name || "",
							is_active: this.value.student_care_1?.is_active,
					  }
				: {
						id: this.value.student_care_1.id || 0,
						full_name: this.value.student_care_1.full_name || "",
						is_active: this.value.student_care_1.is_active,
				  },
			input_co_teacher_id: this.value
				? this.value.co_teacher
					? {
							id: this.value.co_teacher.id || 0,
							full_name: this.value.co_teacher.full_name || "",
							is_active: this.value.co_teacher.is_active,
					  }
					: {
							id: this.value.co_teacher?.id || 0,
							full_name: this.value.co_teacher?.full_name || "",
							is_active: this.value.co_teacher?.is_active,
					  }
				: {
						id: this.value.co_teacher.id || 0,
						full_name: this.value.co_teacher.full_name || "",
						is_active: this.value.co_teacher.is_active,
				  },
			input_student_care_2_id: this.value
				? this.value.student_care_2
					? {
							id: this.value.student_care_2.id || 0,
							full_name:
								this.value.student_care_2.full_name || "",
							is_active: this.value.student_care_2.is_active,
					  }
					: {
							id: this.value.student_care_2?.id || 0,
							full_name:
								this.value.student_care_2?.full_name || "",
							is_active: this.value.student_care_2?.is_active,
					  }
				: {
						id: this.value.student_care_2.id || 0,
						full_name: this.value.student_care_2.full_name || "",
						is_active: this.value.student_care_2.is_active,
				  },
			input_teacher_trainer_id: this.value
				? this.value.teacher_trainer
					? {
							id: this.value.teacher_trainer.id || 0,
							full_name:
								this.value.teacher_trainer.full_name || "",
							is_active: this.value.teacher_trainer.is_active,
					  }
					: {
							id: this.value.teacher_trainer?.id || 0,
							full_name:
								this.value.teacher_trainer?.full_name || "",
							is_active: this.value.teacher_trainer?.is_active,
					  }
				: {
						id: this.value.teacher_trainer.id || 0,
						full_name: this.value.teacher_trainer.full_name || "",
						is_active: this.value.teacher_trainer.is_active,
				  },
			input_sc_supervisor_id: this.value
				? this.value.sc_supervisor
					? {
							id: this.value.sc_supervisor.id || 0,
							full_name: this.value.sc_supervisor.full_name || "",
							is_active: this.value.sc_supervisor.is_active,
					  }
					: {
							id: this.value.sc_supervisor?.id || 0,
							full_name:
								this.value.sc_supervisor?.full_name || "",
							is_active: this.value.sc_supervisor?.is_active,
					  }
				: {
						id: this.value.sc_supervisor.id || 0,
						full_name: this.value.sc_supervisor.full_name || "",
						is_active: this.value.sc_supervisor.is_active,
				  },
			classInformationForm: {},
		};
	},
	created() {
		let url = window.location.href;
		this.id = parseInt(url.split("/").slice(-1)[0].split("?")[0]);

		this.fetchData();
	},
	mounted() {},
	methods: {
		async fetchData() {
			try {
				let [userResponse] = await Promise.all([
					axios.get("/user-list?per_page=50"),
				]);

				userResponse.data.data.forEach((item) => {
					// this.requestedByLists.push({
					// 	id: item.id,
					// 	value: item.full_name ? item.full_name : item.first_name + " " + item.last_name,
					// });
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		beforeSubmit() {
			this.preloader = true;
		},
		submitClassInformation() {
			this.save(this.classInformationForm);
		},
		afterSuccess(res) {
			this.$toastr.s(res.data.message);
			this.clear();
		},
		afterFinalResponse() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterError(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		setCourseIdValue(data) {
			this.basicInfo.course_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.basicInfo.course_id = data.id;
			}
		},
		setGroupCourseIdValue(data) {
			this.basicInfo.group_course_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.basicInfo.group_course_id = data.id;
			}
		},
		setMainTeacherIdValue(data) {
			this.basicInfo.main_teacher_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.basicInfo.main_teacher_id = data.id;
			}
		},
		setStudentCare1IdValue(data) {
			this.basicInfo.student_care_1_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.basicInfo.student_care_1_id = data.id;
			}
		},
		setCourseTypeIdValue(data) {
			this.basicInfo.course_type_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.basicInfo.course_type_id = data.id;
			}
		},
		setCoTeacherIdValue(data) {
			this.basicInfo.co_teacher_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.basicInfo.co_teacher_id = data.id;
			}
		},
		setStudentCare2IdValue(data) {
			this.basicInfo.student_care_2_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.basicInfo.student_care_2_id = data.id;
			}
		},
		setCenterIdValue(data) {
			this.basicInfo.center_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.basicInfo.center_id = data.id;
			}
		},
		setTeacherTrainerIdValue(data) {
			this.basicInfo.teacher_trainer_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.basicInfo.teacher_trainer_id = data.id;
			}
		},
		setScSupervisorIdValue(data) {
			this.basicInfo.sc_supervisor_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.basicInfo.sc_supervisor_id = data.id;
			}
		},

		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(value);
		},
	},
	watch: {},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 40px;
}
.form-control {
	border: 3px solid; /* You can adjust the border color and width as needed = #c41a1a !important; */
}
.required-star {
	color: red;
}

.card {
	box-shadow: 0 18px 20px rgba(0, 0, 0, 0.2); /* You can adjust the values to control the shadow effect */
}
</style>
